export default [
	{
		numero_cte: '00001',
		cidade: 'Nova Lima',
		empresa: 'JM',
		status: 'Aguardando',
		remetente: 'MCIRURGICA MONTEBELLO LTDA',
		notas: [
			{
				acao: 'atualizar',
				ar_nota: '190111627933000200000015410',
				cnpj_dist: '11627933000200',
				cnpj_transp: '10908192000192',
				numero_nota: '000015410',
				pos_entrega: 0,
				serie_nota: '020'
			},
			{
				acao: 'atualizar',
				ar_nota: '190148113906000572000000223',
				cnpj_dist: '48113906000572',
				cnpj_transp: '10908192000192',
				numero_nota: '000000223',
				pos_entrega: 1,
				serie_nota: '020',
				_id: '5c6d4c662b282149d26fda42'
			},
			{
				acao: 'atualizar',
				ar_nota: '190148113906000572000000224',
				cnpj_dist: '48113906000572',
				cnpj_transp: '10908192000192',
				numero_nota: '000000224',
				pos_entrega: 2,
				serie_nota: '020',
				_id: '5c6d4c662b282149d26fda43'
			},
			{
				acao: 'atualizar',
				ar_nota: '190148113906000572000000223',
				cnpj_dist: '48113906000572',
				cnpj_transp: '10908192000192',
				numero_nota: '000000223',
				pos_entrega: 1,
				serie_nota: '020',
				_id: '5c6d4c662b282149d26fda42'
			},
			{
				acao: 'atualizar',
				ar_nota: '190148113906000572000000224',
				cnpj_dist: '48113906000572',
				cnpj_transp: '10908192000192',
				numero_nota: '000000224',
				pos_entrega: 2,
				serie_nota: '020',
				_id: '5c6d4c662b282149d26fda43'
			}
		]
	},
	{
		numero_cte: '00002',
		cidade: 'Nova Lima',
		empresa: 'JM',
		status: 'Aprovado',
		remetente: 'MCIRURGICA MONTEBELLO LTDA',
		notas: [
			{
				acao: 'atualizar',
				ar_nota: '190111627933000200000015410',
				cnpj_dist: '11627933000200',
				cnpj_transp: '10908192000192',
				numero_nota: '000015410',
				pos_entrega: 0,
				serie_nota: '020'
			},
			{
				acao: 'atualizar',
				ar_nota: '190148113906000572000000223',
				cnpj_dist: '48113906000572',
				cnpj_transp: '10908192000192',
				numero_nota: '000000223',
				pos_entrega: 1,
				serie_nota: '020',
				_id: '5c6d4c662b282149d26fda42'
			},
			{
				acao: 'atualizar',
				ar_nota: '190148113906000572000000224',
				cnpj_dist: '48113906000572',
				cnpj_transp: '10908192000192',
				numero_nota: '000000224',
				pos_entrega: 2,
				serie_nota: '020',
				_id: '5c6d4c662b282149d26fda43'
			},
			{
				acao: 'atualizar',
				ar_nota: '190148113906000572000000223',
				cnpj_dist: '48113906000572',
				cnpj_transp: '10908192000192',
				numero_nota: '000000223',
				pos_entrega: 1,
				serie_nota: '020',
				_id: '5c6d4c662b282149d26fda42'
			},
			{
				acao: 'atualizar',
				ar_nota: '190148113906000572000000224',
				cnpj_dist: '48113906000572',
				cnpj_transp: '10908192000192',
				numero_nota: '000000224',
				pos_entrega: 2,
				serie_nota: '020',
				_id: '5c6d4c662b282149d26fda43'
			}
		]
	},
	{
		numero_cte: '00003',
		cidade: 'Nova Lima',
		empresa: 'JM',
		status: 'Aprovado',
		remetente: 'MCIRURGICA MONTEBELLO LTDA',
		notas: [
			{
				acao: 'atualizar',
				ar_nota: '190111627933000200000015410',
				cnpj_dist: '11627933000200',
				cnpj_transp: '10908192000192',
				numero_nota: '000015410',
				pos_entrega: 0,
				serie_nota: '020'
			},
			{
				acao: 'atualizar',
				ar_nota: '190148113906000572000000223',
				cnpj_dist: '48113906000572',
				cnpj_transp: '10908192000192',
				numero_nota: '000000223',
				pos_entrega: 1,
				serie_nota: '020',
				_id: '5c6d4c662b282149d26fda42'
			},
			{
				acao: 'atualizar',
				ar_nota: '190148113906000572000000224',
				cnpj_dist: '48113906000572',
				cnpj_transp: '10908192000192',
				numero_nota: '000000224',
				pos_entrega: 2,
				serie_nota: '020',
				_id: '5c6d4c662b282149d26fda43'
			},
			{
				acao: 'atualizar',
				ar_nota: '190148113906000572000000223',
				cnpj_dist: '48113906000572',
				cnpj_transp: '10908192000192',
				numero_nota: '000000223',
				pos_entrega: 1,
				serie_nota: '020',
				_id: '5c6d4c662b282149d26fda42'
			},
			{
				acao: 'atualizar',
				ar_nota: '190148113906000572000000224',
				cnpj_dist: '48113906000572',
				cnpj_transp: '10908192000192',
				numero_nota: '000000224',
				pos_entrega: 2,
				serie_nota: '020',
				_id: '5c6d4c662b282149d26fda43'
			}
		]
	},
	{
		numero_cte: '00003',
		cidade: 'Nova Lima',
		empresa: 'JM',
		status: 'Aguardando',
		remetente: 'MCIRURGICA MONTEBELLO LTDA',
		notas: [
			{
				acao: 'atualizar',
				ar_nota: '190111627933000200000015410',
				cnpj_dist: '11627933000200',
				cnpj_transp: '10908192000192',
				numero_nota: '000015410',
				pos_entrega: 0,
				serie_nota: '020'
			},
			{
				acao: 'atualizar',
				ar_nota: '190148113906000572000000223',
				cnpj_dist: '48113906000572',
				cnpj_transp: '10908192000192',
				numero_nota: '000000223',
				pos_entrega: 1,
				serie_nota: '020',
				_id: '5c6d4c662b282149d26fda42'
			},
			{
				acao: 'atualizar',
				ar_nota: '190148113906000572000000224',
				cnpj_dist: '48113906000572',
				cnpj_transp: '10908192000192',
				numero_nota: '000000224',
				pos_entrega: 2,
				serie_nota: '020',
				_id: '5c6d4c662b282149d26fda43'
			},
			{
				acao: 'atualizar',
				ar_nota: '190148113906000572000000223',
				cnpj_dist: '48113906000572',
				cnpj_transp: '10908192000192',
				numero_nota: '000000223',
				pos_entrega: 1,
				serie_nota: '020',
				_id: '5c6d4c662b282149d26fda42'
			},
			{
				acao: 'atualizar',
				ar_nota: '190148113906000572000000224',
				cnpj_dist: '48113906000572',
				cnpj_transp: '10908192000192',
				numero_nota: '000000224',
				pos_entrega: 2,
				serie_nota: '020',
				_id: '5c6d4c662b282149d26fda43'
			}
		]
	},
	{
		numero_cte: '00003',
		cidade: 'Nova Lima',
		empresa: 'JM',
		status: 'Aprovado',
		remetente: 'MCIRURGICA MONTEBELLO LTDA',
		notas: [
			{
				acao: 'atualizar',
				ar_nota: '190111627933000200000015410',
				cnpj_dist: '11627933000200',
				cnpj_transp: '10908192000192',
				numero_nota: '000015410',
				pos_entrega: 0,
				serie_nota: '020'
			}
		]
	},
	{
		numero_cte: '00003',
		cidade: 'Nova Lima',
		empresa: 'JM',
		status: 'Aprovado',
		remetente: 'MCIRURGICA MONTEBELLO LTDA',
		notas: [
			{
				acao: 'atualizar',
				ar_nota: '190111627933000200000015410',
				cnpj_dist: '11627933000200',
				cnpj_transp: '10908192000192',
				numero_nota: '000015410',
				pos_entrega: 0,
				serie_nota: '020'
			}
		]
	},
	{
		numero_cte: '00003',
		cidade: 'Nova Lima',
		empresa: 'JM',
		status: 'Aprovado',
		remetente: 'MCIRURGICA MONTEBELLO LTDA',
		notas: [
			{
				acao: 'atualizar',
				ar_nota: '190111627933000200000015410',
				cnpj_dist: '11627933000200',
				cnpj_transp: '10908192000192',
				numero_nota: '000015410',
				pos_entrega: 0,
				serie_nota: '020'
			}
		]
	},
	{
		numero_cte: '00003',
		cidade: 'Nova Lima',
		empresa: 'JM',
		status: 'Aprovado',
		remetente: 'MCIRURGICA MONTEBELLO LTDA',
		notas: [
			{
				acao: 'atualizar',
				ar_nota: '190111627933000200000015410',
				cnpj_dist: '11627933000200',
				cnpj_transp: '10908192000192',
				numero_nota: '000015410',
				pos_entrega: 0,
				serie_nota: '020'
			}
		]
	}
];
